export default {
      id: "status_win-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#status_win-usage",
      toString: function () {
        return this.url;
      }
    }